import { dateUtils, translationUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { Table } from '@festina-life/ui/listsAndTables'

import { useTranslateLayer } from '../../hooks/useTranslateLayer'
import type { TemplateVersionInfo } from '../../types/templateModel'
import { InheritanceTooltipRow } from './InheritanceTooltipRow'

type Props = {
  versionInfo: TemplateVersionInfo
}

export function InheritanceTooltip({ versionInfo }: Props) {
  const translate = useTranslate()
  const translateLayer = useTranslateLayer()

  return (
    <Table className="border-collapse">
      <tbody>
        <InheritanceTooltipRow
          label={translate(
            'templateViewer.sidebar.inheritanceDiagram.tooltip.templateVersion.identifier',
          )}
          value={versionInfo.identifier}
        />
        <InheritanceTooltipRow
          label={translate(
            'templateViewer.sidebar.inheritanceDiagram.tooltip.templateVersion.layer',
          )}
          value={translateLayer(versionInfo.layer)}
        />
        <InheritanceTooltipRow
          label={translate(
            'templateViewer.sidebar.inheritanceDiagram.tooltip.templateVersion.package',
          )}
          value={versionInfo.package?.join('.') ?? '-'}
        />
        <InheritanceTooltipRow
          label={translate(
            'templateViewer.sidebar.inheritanceDiagram.tooltip.templateVersion.replaces',
          )}
          value={versionInfo.replacesId ?? '-'}
        />
        <InheritanceTooltipRow
          label={translate(
            'templateViewer.sidebar.inheritanceDiagram.tooltip.templateVersion.replacedBy',
          )}
          value={versionInfo.replacedByIds?.join(', ') ?? '-'}
        />
        <InheritanceTooltipRow
          label={translate(
            'templateViewer.sidebar.inheritanceDiagram.tooltip.templateVersion.fromDate',
          )}
          value={dateUtils.dateAsStr(versionInfo.fromDate)}
        />
        <InheritanceTooltipRow
          label={translate(
            'templateViewer.sidebar.inheritanceDiagram.tooltip.templateVersion.isDraft',
          )}
          value={translationUtils.translateBoolean(
            versionInfo.isDraft,
            translate,
          )}
        />
      </tbody>
    </Table>
  )
}
